module.exports = __webpack_public_path__ + "img/verdi_loader.9bb04bcd.svg";